
import { useEffect, useRef } from "react";
import { Terminal } from '@xterm/xterm';
import "@xterm/xterm/css/xterm.css";
import { FitAddon } from '@xterm/addon-fit';
import { ITerminalOptions, ITerminalInitOnlyOptions } from '@xterm/xterm';
import { io } from "socket.io-client";
import { OverlayAddon } from "./overlay";

export const WebTerminal = ({name, id}) => {
  const xtermContainerRef = useRef(null);
  //const lineCharsRef = useRef([]);
  const key = useRef(Math.random().toString(36).substr(2, 9));
  const canInputRef = useRef(false);

  useEffect(() => {
    const xterm = new Terminal({
      cursorBlink: true,
      disableStdin: false,
      fontSize: 14,
      fontFamily: 'Consolas, "Courier New", monospace',
    });
    const fitAddon = new FitAddon();
    const overlayAddon = new OverlayAddon();
    xterm.loadAddon(fitAddon);
    xterm.loadAddon(overlayAddon);
  
    xterm.open(xtermContainerRef.current);
    fitAddon.fit();

    const disposables = [];
    

    let cols = xterm.cols;
    let rows = xterm.rows;
    console.log(`>>> Web terminal, rows:${rows}, cols:${cols}`);
    const socket = io(window.location.origin,{
      "path":"/api/v1/provision/socket.io",
      "query": `key=${key.current}&type=ssh&pod_name=${name}&namespace=${id}&rows=${rows}&cols=${cols}`,
      "transports": ["websocket"]
    });

    socket.on("connect_error", (err) => {
      // the reason of the error, for example "xhr poll error"
      console.log(">>>" + err.message);
    
      // some additional description, for example the status code of the initial HTTP response
      console.log(">>>" + err.description);
    
      // some additional context, for example the XMLHttpRequest object
      console.log(">>>" + err.context);
    });

    socket.on(key.current, (msg) => {
      if(msg.data){                  
        xterm.write(msg.data);       
        //canInputRef.current = true; 
      } else {
        xterm.writeln("\x1B[1;3;31mError in remote server...\x1B[0m");
      }
    });
    socket.on("connect", () => {
      canInputRef.current = true;
      xterm.focus();
      disposables.push(
        xterm.onResize(({ cols, rows }) => {
          socket.emit(key.current, {op:"resize", cols:cols, rows:rows});
          overlayAddon.showOverlay(`${cols}x${rows}`, 300);
        })
      );
    });
    socket.on("disconnect", () => {
      canInputRef.current = false;
      xterm.writeln("\x1B[1;3;31mDisconnected...\x1B[0m");
      xterm.blur();
    });
    disposables.push(
      xterm.onData(function (data) {
        if(canInputRef.current){
          socket.emit(key.current, {op:"stdin", data:data});
        }
      })
    );
    disposables.push(
      xterm.onSelectionChange(() => {
        if (xterm.getSelection() === '') return;
        try {
            document.execCommand('copy');
        } catch (e) {
            return;
        }
        overlayAddon.showOverlay('\u2702', 200);
    })
    );
    window.addEventListener('resize', () => fitAddon.fit());
  
    return () => {
      for (const d of disposables) {
        d.dispose();
      }
      xterm.dispose();
      if(socket){
        socket.disconnect();
      }
    };
  }, [name, id]); 

  return <div ref={xtermContainerRef} style={{ width: '100%', height: '100%' }} />;
}